<div
  class="h-full cursor-pointer relative book-widget-select-dropdown"
  [ngClass]="{ 'hide-dropdown-list-icon': hideDropdownListIcon }"
>
  <ng-template
    [ngTemplateOutlet]="
      hasInfoTooltip ? dropdownButtonWithIconTemplate : dropdownButtonTemplate
    "
  ></ng-template>
</div>

<ng-template #dropdownButtonWithIconTemplate>
  <div class="flex dropdown-icon-container flex-row-reverse">
    <idp-info-tooltip-mach-core
      class="self-center info-icon right-4"
      [infoModalContent]="infoModalContent"
      [tooltipOptions]="infoTooltipOptions"
    ></idp-info-tooltip-mach-core>
    <ng-container [ngTemplateOutlet]="dropdownButtonTemplate"></ng-container>
  </div>
</ng-template>
<ng-template #dropdownButtonTemplate>
  <button
    class="dropdown h-[inherit] w-full !border-stroke-01"
    [disabled]="disabled"
    [ngClass]="{
      custom_dropdown_list_width: isVariableWidthDropdown,
      '!justify-start': hasInfoTooltip
    }"
    [id]="selectElementId"
    [attr.aria-expanded]="false"
    role="combobox"
  ></button>
</ng-template>
